module.exports = __webpack_public_path__ + "static/media/delete.222f5312.svg";